import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import { getLoadingState, getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { BirthsTableService } from 'src/app/modules/acbcr/common/services/births-table.service';


@Component({
  selector: 'app-births',
  templateUrl: './births.component.html',
  styleUrls: ['./births.component.scss'],
})
export class BirthsComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  tables$: Observable<any[]>;
  total$: Observable<number>;
  currentRoute: string;
  loadingDataSpinner = false;
  selectedHolding;

  objToAPI = {
    companyid: null,
    data_start: null,
    data_end: null,
    sex: null,
    rang_fatare: null,
    usurinta_fatare: null,
    page_nr: '1',
    page_size: '10'
  };

  constructor(
    private birthsTableService: BirthsTableService,
    private store: Store<ApplicationState>,
    private helperDataService: HelperDataService,
  ) {
    this.tables$ = birthsTableService.tables$;
    this.total$ = birthsTableService.total$;
  }

  ngOnInit(): void {
    this.store.pipe(select(getCurrentRoute))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: string) => {
        this.currentRoute = response;
      });

    this.store.pipe(
      select(getLoadingState),
      filter(isLoading => !isLoading),
      switchMap(() => this.store.pipe(select(getSelectedHolding))),
      distinctUntilChanged((prev, curr) => prev.id === curr.id),
      takeUntil(this.destroy$),
    ).subscribe((response: any) => {
      if (this.currentRoute.includes('/exploatatie')) {
        this.objToAPI['companyid'] = response?.id
      } else {
        this.objToAPI['companyid'] = null;
      }

      this.changePageSize('10');
    });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getTableData() {
    this.loadingDataSpinner = true;
    this.birthsTableService
      .getBirthsAPI(this.objToAPI)
      .subscribe((response) => {
        this.loadingDataSpinner = false;
      });
  }

  filterSearchData(event) {
    this.objToAPI = {
      ...this.objToAPI,
      ...event,
    };

    this.getTableData();
  }

  exportData(event) {
    this.loadingDataSpinner = true;
    let now = UIHelper.now();
    let fisier = `Fatari_Anexa8_${now}.xls`;

    this.birthsTableService
      .exportXLS(this.objToAPI)
      .subscribe({
        next: (response) => {
          this.loadingDataSpinner = false;
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload( blob, fisier);
        },
        error: (errors) => {
          this.loadingDataSpinner = false;
        }
      });
  }

  changePageSize(event) {
    this.objToAPI.page_size = event;
    this.objToAPI.page_nr = '1';
    this.birthsTableService.page = 1;
    this.birthsTableService.pageSize = event;
    this.getTableData();
  }

  changePageNumber(event) {
    this.objToAPI.page_nr = event;
    this.getTableData();
  }

  getCallbackResult(event) {
    this.getTableData();
  }
}
